import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Chip,
  Button,
  Stack,
  Box,
} from "@mui/material";

export default function CategoryCard({
  name,
  location,
  image,
  description,
  rating,
  reviews,
  propertyHighlights,
  roomFacilities,
}) {
  const navigate=useNavigate()
  return (
    <Card
      sx={{
        maxWidth: 420,
        margin: "20px auto",
        borderRadius: 3,
        display: "flex",
        flexDirection: "column",
        boxShadow: 2, // lighter shadow for minimal look
        overflow: "hidden",
      }}
    >
      <CardMedia
        component="img"
        height="200"
        image={image}
        alt={name}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        {/* Property Name & Location */}
        <Typography variant="h6" fontWeight="700" gutterBottom>
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {location}
        </Typography>

        {/* Ratings */}
        <Box display="flex" alignItems="center" mb={1}>
          <Chip
            label={rating}
            color="primary"
            size="small"
            sx={{ fontWeight: "700", mr: 1 }}
          />
          <Typography variant="body2" color="text.primary">
            Wonderful · {reviews} reviews
          </Typography>
        </Box>

        {/* Description */}
        <Typography variant="body2" color="text.secondary" mb={2}>
          {description}
        </Typography>

        {/* Property Highlights */}
        <Typography variant="subtitle2" fontWeight="700" gutterBottom>
          Property Highlights
        </Typography>
        <Stack direction="row" flexWrap="wrap" sx={{ gap: "4px", mb: 1 }}>
          {propertyHighlights.map((item) => (
            <Chip
              key={item}
              label={item}
              size="small"
              color="primary"
              variant="outlined"
            />
          ))}
        </Stack>

        {/* Room Facilities */}
        <Typography variant="subtitle2" fontWeight="700" gutterBottom>
          Room Facilities
        </Typography>
        <Stack direction="row" flexWrap="wrap" sx={{ gap: "4px", mb: 1 }}>
          {roomFacilities.slice(0, 5).map((item) => (
            <Chip
              key={item}
              label={item}
              size="small"
              color="secondary"
              variant="outlined"
            />
          ))}
          {roomFacilities.length > 5 && (
            <Chip label={`+${roomFacilities.length - 5} more`} size="small" variant="outlined" />
          )}
        </Stack>
      </CardContent>

      {/* Book Reservation Button */}
      <Box sx={{ p: 2 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ borderRadius: 2, fontWeight: 700, textTransform: "none" }}
          onClick={()=> navigate('/roomdetails')}
        >
          Book Reservation
        </Button>
      </Box>
    </Card>
  );
}
